<template>
    <div class="about-view" v-loading="loading">
        <div class="row">
            <div class="col-md-12">
                <el-form ref="aboutForm" :model="page.form" :rules="page.formRules" label-width="150px">

                        <div class="row">
                            <div class="col-md-6">
                                <el-form-item label="Image" prop="img">
                                    <div class="uploadDrag">
                                        <input
                                            type="file"
                                            id="fileUpload"
                                            ref="file"
                                            name="file"
                                            class="c-input u-sb-small"
                                            @change="handleChange()">
                                        <p id="fileUploadText">{{page.fileSelect}}</p>
                                    </div>
                                </el-form-item>
                            </div>

                            <div class="col-md-6 img-select" v-if="page.fileData != null">
                                <img :src="page.fileData" class="selected-img">
                                <div class="middle">
                                    <div class="text" @click="handleRemove">Remove</div>
                                </div>
                            </div>

                        </div>

                        <el-form-item label="Label" prop="label">
                            <el-input v-model="page.form.label" ref="label"></el-input>
                        </el-form-item>

                        <el-form-item label="Content" prop="content">
                            <vue-editor v-model="page.form.content" ref="content" :editorToolbar="customToolbar" ></vue-editor>
                        </el-form-item>
                    
                     <el-form-item>
                        <el-button :loading="page.updateBtnLoad" @click="setData" type="primary">Update</el-button>
                    </el-form-item>
                    


                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import {generateHeader, handleFileType, handleFileSize} from "@/misc/function.js";
import { VueEditor } from "vue2-editor";
export default {
    components: {
        VueEditor
    },
    data () {
        const validLabel = (rule, value, callback) => {
            if (!value) {
                callback(new Error('Please fill the Label'))
            } else {
                callback()
            }
        }
        const validContent = (rule, value, callback) => {
            if (!value) {
                callback(new Error('Please fill the Content'))
            } else {
                callback()
            }
        }
        const validImg = (rule, value, callback) => {
            if (!value) {
                callback(new Error('Please Select File'))
            } else {
                callback()
            }
        } 
        return {
            customToolbar: [["bold", "italic", "underline"], [{ list: "ordered" }, { list: "bullet" }]],
            loading: false,
            rights: {
                page: true,
            },
            fileError: false,
            page: {
                updateBtnLoad: false,
                formValid: false,
                fileSelect: 'Drag your files here or click in this area.',
                fileData: null,
                form: {
                    img: '',
                    label: '',
                    content: ''
                },
                formRules: {
                    label: [{ required: true, trigger: 'blur', validator: validLabel }],
                    content: [{ required: true, trigger: 'blur', validator: validContent }],
                    img: [{ required: true, trigger: 'blur', validator: validImg }]
                }
            }
        }
    },
    methods: {
        init(){
            this.getRights()
        },
        //
        handleRemove(){
            this.page.fileData = null,
            this.page.fileSelect = "Drag your files here or click in this area.",
            this.page.form.img = ''
        },
        handleChange() {
            this.page.form.img = this.$refs.file.files[0]
            if(handleFileSize(1393750 , this.page.form.img.size) == "false"){
                this.fileError = true
                this.$notify.info({
                    title: 'Info',
                    message: "File Size Too Large. Please Upload less then 1MB File !!!"
                });
            }
            var allowed_type = ['image/png' , 'image/jpg' , 'image/jpeg']
            if(handleFileType(allowed_type , this.page.form.img.type) == "false"){
                this.fileError = true
                this.$notify.info({
                    title: 'Info',
                    message: "File Type Invalid. Please Upload Only png , jpg or jpeg type !!!"
                });
            }
            
            if(!this.fileError){

                this.page.fileSelect = "File Selected"
                const input = this.$refs.file
                const files = input.files
                if (files && files[0]) {
                    const reader = new FileReader
                    reader.onload = e => {
                    this.page.fileData = e.target.result
                    }
                    reader.readAsDataURL(files[0])
                    this.$emit('input', files[0])
                }
            }
            else{
                this.page.form.img = ""
                this.fileError = false
            }
        },
        handleFormValid(formRef){
            this.$refs[formRef].validate((valid) => {
                if(valid){
                    this.page.formValid = true

                    if(this.page.form.img == ""){
                        this.page.formValid = false
                    }
                }
                else{
                    this.page.formValid = false
                }
            });
        },
            getRights() {
                this.loading = true
                this.$axios.post('about/rights.php' , {} , {
                    headers: generateHeader("aboutRights")
                })
                .then((response) => {
                    if(response.data.code == "200"){
                        //Whole Page Right
                        this.rights.page = response.data.body.rights.about_page == 1 ? true : false
                        if(this.rights.page){
                            this.getData();
                        }
                    }
                    else if(response.data.code == "403"){
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                        this.$router.push('/admin/dashboard')
                    }
                    else if (response.data.code == "401"){
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                        localStorage.clear()
                        this.$router.push('/login')
                    }
                    else{
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                    }
                    this.loading = false
                })
                .catch((error) => {
                    this.$notify.error({
                        title: 'Error',
                        message: error
                    });
                    this.loading = false
                })
            },
        getData() {
            this.loading = true
            this.$axios.post("about/get.php" , {}, {
                headers: generateHeader("getAboutData")
            })
            .then((response) => {
                if(response.data.code == "200"){
                    this.page.form.label = response.data.body.label
                    this.page.form.content = response.data.body.content

                    if(response.data.body.fileURL != ""){
                        this.page.form.img = response.data.body.fileName
                        this.page.fileSelect = "File Selected"

                        this.page.fileData = response.data.body.fileURL
                    }
                    else{
                        this.page.form.img = ""
                        this.page.fileSelect = "Drag your files here or click in this area."
                        this.page.fileData = null
                    }
                }
                else if(response.data.code == "404"){
                    this.page.form.label = ""
                    this.page.form.content = ""
                    this.page.form.img = ""
                    this.page.fileSelect = "Drag your files here or click in this area."
                    this.page.fileData = null
                }
                else if (response.data.code == "401"){
                    this.$notify.info({
                        title: 'Info',
                        message: response.data.extra.message
                    });
                    localStorage.clear()
                    this.$router.push('/login')
                }
                else{
                    this.$notify.info({
                        title: 'Info',
                        message: response.data.extra.message
                    });
                }
                this.loading = false
            })
            .catch((error) => {
                this.$notify.error({
                    title: 'Error',
                    message: error                       
                });
                this.loading = false
            })
        },
        setData() {
            this.handleFormValid("aboutForm")
            if(this.page.formValid){

                this.page.updateBtnLoad = true
                
                let formData = new FormData()
                formData.append('file', this.page.form.img)
                formData.append('label', this.page.form.label)
                formData.append('content', this.page.form.content)

                
                this.$axios.post("about/set.php" ,formData, {
                    headers: generateHeader("setAboutData" , true)
                })
                .then((response) => {
                    if(response.data.code == "204"){
                        this.$notify.success({
                            title: 'Success',
                            message: response.data.extra.message
                        });
                        this.getData()
                    }
                    else if(response.data.code == "412"){
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                    }
                    else if (response.data.code == "401"){
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                        localStorage.clear()
                        this.$router.push('/login')
                    }
                    else{
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                    }
                    this.page.updateBtnLoad = false
                })
                .catch((error) => {
                    this.$notify.error({
                        title: 'Error',
                        message: error                       
                    });
                    this.page.updateBtnLoad = false
                })
            }
        }
    },
    mounted() {
        // this.getData()
        this.init()
    }
}
</script>

<style>
    .uploadDrag{
        /* position: absolute; */
        width: 100%;
        height: 200px;
        border: 4px dashed #000;
    }
    #fileUpload{
        position: absolute;
        margin: 0;
        padding: 0;
        width: 100%;
        height: 100%;
        outline: none;
        opacity: 0;
    }
    #fileUploadText{
        width: 100%;
        height: 100%;
        text-align: center;
        line-height: 170px;
        color: #000;
        font-family: Arial;
    }

    .selected-img{
        height: 200px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        text-align: center;
    }

    .middle {
        /* transition: .5s ease; */
        opacity: 0;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        text-align: center;

        background: #000;
        padding: 10px;
        color: #fff;
        border-radius: 5px;
        cursor: pointer;
    }

    .img-select:hover .selected-img{
        opacity: 0.3;
    }

    .img-select:hover .middle{
        opacity: 1;
    }
</style>